module.exports = __webpack_public_path__ + "static/media/G4.1b77e15b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gp/G4.jpg
// module id = 77
// module chunks = 0